import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { PendientesCargaDescarga as Comp } from "app/features/componentes/cargas";
export interface Props {
    /**Id de la carga/descarga */
    idDescargaZE: number;
}

/**Dado el idCargaDescarga muestra los sobres y paquetes pendientesk */
export class PendientesDescargaZE extends React.PureComponent<Props> {
    idDescargaZE = (props: Props) => props.idDescargaZE;
    pendientes = createSelectorRx(this.idDescargaZE, idDescargaZE => observeResource(resources.DescargaZE.ObtenerServiciosPendientes, idDescargaZE));

    onQuitarPaquete = async (x: models.PaquetePendienteDto) => {
        const idDescargaZE = this.props.idDescargaZE;
        await resources.DescargaZE.QuitarServicioIncompleto(idDescargaZE, x.IdServicio, x.NumeroFisico, models.TipoFolioFisico.Paquete);
    }

    onQuitarSobre = async (x: models.SobrePendienteDto) => {
        const idDescargaZE = this.props.idDescargaZE;
        await resources.DescargaZE.QuitarServicioIncompleto(idDescargaZE, x.IdServicio, x.NumeroFisico, models.TipoFolioFisico.Sobre);
    }

    render() {
        const val = this.pendientes(this.props);
        return <Comp
            value={val}
            onQuitarPaquete={this.onQuitarPaquete}
            onQuitarSobre={this.onQuitarSobre}
        />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/descargaze/edit/status/items/pendientes/index.tsx